import {
  EntityAdapter,
  EntityState as ngEntityState,
  createEntityAdapter,
} from "@ngrx/entity";
import {UserModel} from "./user.model";

export const userModelEntityAdapter: EntityAdapter<UserModel> =
    createEntityAdapter<UserModel>();

export interface UsersState extends ngEntityState<UserModel> {
  subscribedToUserIds: string[];
}

export const initialState: UsersState = userModelEntityAdapter
    .getInitialState({
        subscribedToUserIds: [],
    });
